import { createRoot } from 'react-dom/client';
import { StrictMode } from 'react';
import { type RouteComponentProps, Router, Switch, Route } from 'react-router-dom';
import { Provider } from 'react-redux';

import { history } from '@editor2/history';
import { store } from '@editor2/store';
import EditorApp from '@editor2/containers/App';
import JwtAuthGateway from '@editor2/containers/JwtAuth';
import ErrorBoundary from '@editor2/components/ErrorBoundary';
import Error from '@editor2/containers/Error';

const root = createRoot(document.getElementById('root')!);

root.render(
	<StrictMode>
		<Provider store={store}>
			<ErrorBoundary>
				<Router history={history}>
					<Switch>
						<Route path="/courses/:courseId/authentication" component={JwtAuthGateway} />
						<Route
							path="/courses/:courseId"
							render={(props: RouteComponentProps<{ courseId: string }>) => (
								<EditorApp {...props} key={props.match.params.courseId} />
							)}
						/>
						<Route path="/error/:errorType" component={Error} />
					</Switch>
				</Router>
			</ErrorBoundary>
		</Provider>
	</StrictMode>
);
